module.exports = __webpack_public_path__ + "img/author.6f6bee9b.jpg";